import MiScrollArea from './MiScrollArea.vue'

export default MiScrollArea
